import React, { type FC, type ReactNode } from 'react';

import { type ErrorUtils } from '../../utils/ErrorUtils';
import { PfErrorUtilsProvider } from '../ErrorUtilsContext';

export interface PfUtils {
	errorUtils: ErrorUtils;
}

interface UtilsProviderProps {
	utils: PfUtils;
	children: ReactNode;
}

export const UtilsProvider: FC<UtilsProviderProps> = ({ utils, children }) => (
	<PfErrorUtilsProvider errorUtils={utils.errorUtils}>{children}</PfErrorUtilsProvider>
);
